import React, { useState, useEffect } from "react";
import axios from "axios";

import { getUserData } from "../../hooks/HelperFunctions";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import SensorsRoundedIcon from "@mui/icons-material/SensorsRounded";
import "./RunningCourseAlertMessage.css";
import { apiRequest } from "../../utils/axiosInstance";

export default function RunningCourseAlertMessage(props) {
  const [runningCourses, setRunningCourses] = useState([]);
  const [activeAlertCourse, setActiveAlertCourse] = useState([]);
  const [hideAlert, setHideAlert] = useState(false);
  const [courseDetailPath, setCourseDetailPath] = useState("");

  useEffect(() => {
    const orgId = localStorage.getItem("orgId");
    if (props.portal == "org" && orgId > 0) {
      getOrgRunningCourseList(orgId);
      // setCourseDetailPath(`/course-details`);
    } else if (props.portal == "student") {
      getStudentRunningCourseList();
      setCourseDetailPath(`/course-details-learner`);
    }
  }, [props.portal]);

  // update running course data per/1 minute
  useEffect(() => {
    const interval = setInterval(() => {
      if (props.portal == "org") {
        const orgId = localStorage.getItem("orgId");
        getOrgRunningCourseList(orgId);
      } else if (props.portal == "student") {
        getStudentRunningCourseList();
      }
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    runningCourses.forEach((item, i) =>
      setTimeout(
        () => setActiveAlertCourse(item),
        (i + 1) * 15000 // 5000, 10000, 15000
      )
    );
  }, [runningCourses]);

  const getOrgRunningCourseList = async (orgId) => {
      try {
        const data = await apiRequest(`/orgPortal/getRunningCourses?orgId=${orgId}`, 'GET', null);
  
        console.log(data.body, 'running courses of org');
        if (data.body?.length > 0) {
          setRunningCourses(data?.body);
        } else {
          setHideAlert(true);
        }
        
      } catch (error) {
        console.log(error);
      }
  };

  const getStudentRunningCourseList = async () => {
    const userData = getUserData();
    const userId = userData.id;
    try {
      const data = await apiRequest(`/studentPortal/getRunningCourses?userId=${userId}`, 'GET', null);

      console.log(data?.body, 'running courses of student');
      if (data?.body?.length > 0) {
        setRunningCourses(data?.body);
      } else {
        setHideAlert(true);
      }
      
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {!hideAlert && activeAlertCourse && activeAlertCourse.courseTitle && (
        <div className="BlueAlertMessage">
          <div className="BlMessageContainer">
            <div className="BlMessageLeftContainer">
              <SensorsRoundedIcon />
              <div>
                <h2>
                  <span>Live</span>: {activeAlertCourse.sessionTitle}
                </h2>
                <p>{activeAlertCourse.courseTitle}</p>
              </div>
            </div>
            <div className="AlrtMessageContainer">
              {props.portal == "student" && (
                <Button
                  href={`${courseDetailPath}/${activeAlertCourse.courseId}`}
                  className="AlrtButton"
                >
                  Go To Course
                </Button>
              )}
            </div>
          </div>
          <IconButton
            className="BlueAlertMessageIconButton"
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              setHideAlert(true);
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
      )}
    </>
  );
}
